import { Component, OnInit, inject } from '@angular/core';

import { environment } from '../../environments/environment';
import { NavigationBarService } from '../services/navigation-bar/navigation-bar.service';
import { SharingService } from '../sharing/services/sharing.service';

@Component({
  selector: 'app-navigation-bar',
  templateUrl: './navigation-bar.component.html',
  styleUrls: ['./navigation-bar.component.scss'],
  standalone: false,
})
export class NavigationBarComponent implements OnInit {
  private navigationBarService = inject(NavigationBarService);
  private sharingService = inject(SharingService);

  private hasSharedResults!: boolean;
  private isLoading!: boolean;

  public selectionToolUrl = environment.selectionToolUrl;
  public homePageUrl = environment.homePageUrl;
  public sharedResultsPageUrl = environment.sharedResultsPageUrl;

  ngOnInit(): void {
    this.isLoading = true;
    this.checkIfUserHasSharedResults();
  }

  private checkIfUserHasSharedResults(): void {
    this.sharingService.hasSharedResults().subscribe((hasSharedResults) => {
      this.hasSharedResults = hasSharedResults;
      this.isLoading = false;
    });
  }

  get shouldDisplaySharingIcon(): boolean {
    return this.hasSharedResults;
  }

  get isDataLoading(): boolean {
    return this.isLoading;
  }

  public close(): void {
    this.navigationBarService.show(false);
  }
}
